
  
document.addEventListener('DOMContentLoaded', function() {

  var easyspecsTable = document.querySelector('.product-block--collapsible-tab-prod');
  
  if (easyspecsTable !== null) {
      var tabs_heading = document.createElement("h2");
      tabs_heading.classList.add('details__tabs_heading');
      tabs_heading.textContent = "Specification";
    
      easyspecsTable.insertAdjacentElement('afterend', tabs_heading);
    
      var coll = document.getElementsByClassName("details__tabs_heading");
      var i;
      
      for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          } 
        });
      }
      
    }  
});

